'use client';
import CategoryOrSubcategoryPage, {
  CategoryOrSubcategoryPageProps,
} from '@c/CategoryOrSubcategoryPage';
import { trackUserSearch } from '@util/firestore/recommendations';
import { useAuth } from 'context/AuthContext';
import { useSearch } from 'context/SearchContext';
import { injectBreadcrumbScript } from 'features/schemaMarkups';
import { usePathname } from 'next/navigation';
import { useRef, useEffect } from 'react';

export default function CategoryPage({
  current_cat,
  categories,
  category,
  category1,
  category2,
  category3,
  keyword,
  results,
  on_sale,
  pageInfo,
  initialTopFilters,
  initialSideFilters,
  brands,
  allBrands,
  facet_counts,
  shouldUseRecommend,
  h1,
  bottomText,
  color,
  mostly_parts,
}: CategoryOrSubcategoryPageProps) {
  const pathname = usePathname();
  const ref = useRef<any>(null);
  const { user } = useAuth();
  const { setFilters } = useSearch();
  useEffect(() => {
    if (typeof user === 'undefined' || !keyword) return;
    const args = {
      uid: user?.uid,
      brands: initialSideFilters.brands,
      categories: [category, category1, category2, category3].filter(
        Boolean
      ) as string[],
      condition: initialSideFilters.conditions[0],
      gender: initialSideFilters.genders?.[0],
      inserted_time: Date.now(),
      makes: initialSideFilters.bikeMakes,
      models: initialSideFilters.bikeModels,
      on_sale: initialSideFilters.onsale,
      result_count: pageInfo.totalResults,
      color: initialSideFilters.color,
      seller_type: initialSideFilters.sellerType?.[0],
      size: initialSideFilters.letterSizes[0],
      sort: (initialTopFilters.sort === 'bestMatch'
        ? 'Default'
        : initialTopFilters.sort === 'newest'
        ? 'Newest'
        : initialTopFilters.sort === 'priceAsc'
        ? 'Low Price'
        : initialTopFilters.sort === 'priceDesc'
        ? 'High Price'
        : 'Default') as 'Default' | 'Newest' | 'Low Price' | 'High Price',
      term: keyword,
      years: initialSideFilters.bikeYears?.map((y) => +y),
      referrer: window.location.href,
      page: pageInfo.page,
      ride_types: initialSideFilters.rideTypes,
    };
    setFilters(args);
    if (ref.current) clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      trackUserSearch(args);
    }, 1000);
  }, [
    categories,
    category,
    category1,
    category2,
    category3,
    initialSideFilters.bikeMakes,
    initialSideFilters.bikeModels,
    initialSideFilters.bikeYears,
    initialSideFilters.brands,
    initialSideFilters.conditions,
    initialSideFilters.genders,
    initialSideFilters.letterSizes,
    initialSideFilters.onsale,
    initialSideFilters.sellerType,
    initialSideFilters.color,
    initialTopFilters.sort,
    keyword,
    pageInfo.page,
    pageInfo.totalResults,
    setFilters,
    user,
    category,
    category1,
    category2,
    category3,
    initialSideFilters.rideTypes,
  ]);
  return (
    <>
      {current_cat && (
        <script
          id="breadcrumbSchema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: injectBreadcrumbScript({ category: current_cat }) ?? '',
          }}
        />
      )}

      <CategoryOrSubcategoryPage
        key={pathname}
        current_cat={current_cat}
        categories={categories}
        category={category}
        category1={category1}
        category2={category2}
        color={color}
        category3={category3}
        keyword={keyword}
        results={results}
        on_sale={on_sale}
        pageInfo={pageInfo}
        initialTopFilters={initialTopFilters}
        initialSideFilters={initialSideFilters}
        allBrands={allBrands}
        brands={brands}
        facet_counts={facet_counts}
        shouldUseRecommend={shouldUseRecommend}
        h1={h1}
        bottomText={bottomText}
        mostly_parts={mostly_parts}
      />
    </>
  );
}
